export default __webpack_public_path__ + "static/media/Segregação Cargas Perigosas.0b54f869.pdf";